import React from 'react';

export function Arrow({ width = 24, height = 24, color = 'white' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.375 5L3.375 12L10.375 19M20.625 12L4 12"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}